import ReactOnRails from 'react-on-rails/client';
import Translators from '../../app/Translators.jsx';

ReactOnRails.register({Translators});